import React, { useEffect, useState } from 'react';
import './CustomCursor.css';

const CustomCursor = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });

  // Update cursor position on mouse move
  useEffect(() => {
    const moveHandler = e => {
      setPosition({ x: e.clientX, y: e.clientY });
    };

    globalThis.addEventListener('mousemove', moveHandler);
    return () => globalThis.removeEventListener('mousemove', moveHandler);
  }, []);

  return (
    <div
      className='custom-cursor'
      style={{
        left: `${position.x}px`,
        top: `${position.y}px`,
      }}
    />
  );
};

export default CustomCursor;
